<template>
    <CardPage :section="10" :page="7" :nextDisabled="nextDisabled">
        <div v-if="currentRiskActivity">
            <p class="text-xs-center">
                Select the risk level that corresponds with the sex act shown.
            </p>
            <v-fade-transition mode="out-in">
                <v-card :key="currentRiskActivity.text">
                    <v-card-text>
                        <div class="primary--text text-xs-center pa-3">
                            <div>
                                {{ currentRiskActivity.text }}
                                <v-btn flat icon color="primary" class="ma-0" v-if="currentRiskActivity.definition" @click="showDefinition = !showDefinition">
                                    <v-icon>info</v-icon>
                                </v-btn>
                            </div>
                            <v-fade-transition mode="out-in">
                                <div v-if="showDefinition" class="caption black--text">{{ currentRiskActivity.definition }}</div>
                            </v-fade-transition>
                        </div>
                    </v-card-text>
                </v-card>
            </v-fade-transition>
            <v-container fluid grid-list-xs>
                <v-layout row wrap justify-center>
                    <v-flex v-for="(k, i) in riskLevelsOrder" :key="i" xs3>
                        <a @click.prevent="answer(riskLevels[k])">
                            <ResponsiveImage v-ripple :src="riskLevels[k].image" layout="" flex="" :alt="riskLevels[k].title"></ResponsiveImage>
                        </a>
                        <div class="font-weight-bold text-xs-center caption black--text">{{ riskLevels[k].title }}</div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div v-else>
            <p class="text-xs-center">Nice job! Now let’s review the correct risk levels.</p>
            <v-card v-for="(k, i) in riskLevelsOrder" :key="i" class="mb-3">
                <v-card-text>
                    <ResponsiveImage :src="riskLevels[k].image" flex="xs6" :alt="riskLevels[k].title"></ResponsiveImage>
                    <div class="font-weight-bold text-xs-center mb-3">{{ riskLevels[k].title }}</div>
                    <div v-for="(riskActivity, index) in riskActivitiesSorted" :key="index">
                        <div v-if="riskActivity.correctAnswer === riskLevels[k].value" class="grey lighten-3 primary--text px-2 py-1 mb-1">
                            {{ riskActivity.text }}
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </div>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
        <template v-if="nextDisabled()" v-slot:actions>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    data() {
        return {
            showDefinition: false
        };
    },
    computed: {
        riskLevels: get('section10/riskLevels'),
        riskLevelsOrder: get('section10/riskLevelsOrder'),
        riskActivitiesSorted: get('section10/riskActivitiesSorted'),
        currentRiskActivity: get('section10/currentRiskActivity')
    },
    methods: {
        answer(riskLevel) {
            if (this.currentRiskActivity.correctAnswer === riskLevel.value) {
                this.$refs.modalFeedback.show(true, 'Good job!', () => {
                    this.$store.set(`section10/riskActivities@${this.currentRiskActivity.id}.answered`, true);
                    this.showDefinition = false;
                });
            } else {
                this.$refs.modalFeedback.show(false, 'Try again!');
            }
        },
        nextDisabled() {
            return !!this.currentRiskActivity;
        }
    }
};
</script>
